module.exports = __webpack_public_path__ + "img/checkbox-default.c6f556ec.svg";